/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MenuOrder } from './MenuOrder';
import {
    MenuOrderFromJSON,
    MenuOrderFromJSONTyped,
    MenuOrderToJSON,
    MenuOrderToJSONTyped,
} from './MenuOrder';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface GetMenuOrdersResponse
 */
export interface GetMenuOrdersResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetMenuOrdersResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<MenuOrder>}
     * @memberof GetMenuOrdersResponse
     */
    menuOrders: Array<MenuOrder>;
}

/**
 * Check if a given object implements the GetMenuOrdersResponse interface.
 */
export function instanceOfGetMenuOrdersResponse(value: object): value is GetMenuOrdersResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('menuOrders' in value) || value['menuOrders'] === undefined) return false;
    return true;
}

export function GetMenuOrdersResponseFromJSON(json: any): GetMenuOrdersResponse {
    return GetMenuOrdersResponseFromJSONTyped(json, false);
}

export function GetMenuOrdersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrdersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'menuOrders': ((json['menuOrders'] as Array<any>).map(MenuOrderFromJSON)),
    };
}

export function GetMenuOrdersResponseToJSON(json: any): GetMenuOrdersResponse {
    return GetMenuOrdersResponseToJSONTyped(json, false);
}

export function GetMenuOrdersResponseToJSONTyped(value?: GetMenuOrdersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'menuOrders': ((value['menuOrders'] as Array<any>).map(MenuOrderToJSON)),
    };
}

